export enum RootPages {
	StoreSelection = '/store-selection',
	App = '/tabs',
	Backoffice = '/backoffice',
}
